import { render } from "./CZOpenVolume.vue?vue&type=template&id=640d7130&ts=true"
import script from "./CZOpenVolume.vue?vue&type=script&lang=ts"
export * from "./CZOpenVolume.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__